import { render, staticRenderFns } from "./Msg.vue?vue&type=template&id=0690980c&scoped=true&"
import script from "./Msg.vue?vue&type=script&lang=js&"
export * from "./Msg.vue?vue&type=script&lang=js&"
import style0 from "./Msg.vue?vue&type=style&index=0&id=0690980c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0690980c",
  null
  
)

export default component.exports